import _get from 'lodash/get'
import { updateRows } from './list/updateRows'
import { showFormValidationErrors } from './list/showFormValidationErrors'
import { notifyMessage, notifyProblem } from '@/services/notify'
import _cloneDeep from 'lodash/cloneDeep'
import { notifyError } from '@/services/notify'

export const methods = {
  updateRows,

  clear(field) {
    this.formData[field] = null

    if (field === 'name') {
      this.clearName = true
    }
  },

  clearFormErrors() {
    const DEFAULT_FORM_ERRORS = this.DEFAULT_FORM_ERRORS
    this.formErrors = {
      ...DEFAULT_FORM_ERRORS
    }
  },

  async resetForm() {
    this.loading = true

    const DEFAULT_FORM_VALUES = this.DEFAULT_FORM_VALUES
    this.formData = {
      ...DEFAULT_FORM_VALUES
    }

    this.clearFormErrors()

    if (this.$refs.form) {
      this.$refs.form.reset()
    }

    this.loading = false
  },

  setClass(unitGroupID) {
    if (this.isDebug == true) console.debug('...setClass=' + unitGroupID)

    if (this.selectedUnitGroupID == unitGroupID) {
      if (this.isDebug == true) console.debug('true')
      return 'is-selected'
    } else {
      if (this.isDebug == true) console.debug('false')
      return ''
    }
  },

  updateSelected({ id, list }) {
    try {
      this.selectedUnitGroup = list.find(v => {
        return v.unitGroupID === id
      })
    } catch (exception) {
      console.error(exception)
    }
  },

  initButtons() {
    this.selectedID = null
    this.formShow = false
    this.action = ''
    this.formData.UnitGroupUnitID = 0
  },

  showFormValidationErrors,

  // Unit Group methods
  confirmDeleteUnitGroup(id, name) {
    this.$buefy.dialog.confirm({
      title: 'Deleting Unit Group',
      message: `Are you sure you want to <b>delete</b> this unit group: "${name}"?`,
      confirmText: 'Delete Unit Group',
      type: 'is-danger',
      hasIcon: true,
      onConfirm: () => this.deleteUnitGroup(id)
    })
  },

  openAddUnitGroupModal() {
    this.resetForm()
    this.showUnitGroupModal = true
    this.selectedID = null
    this.action = 'add'
    this.formData.UnitGroupUnitID = 0
  },

  getPayloadUnitGroup(isAdd) {
    if (this.isDebug == true) console.debug('this.formData=' + JSON.stringify(this.formData))

    let problem = ''

    console.debug('in getPayloadUnitGroup=' + isAdd)

    if (this.formData.Name === '' && isAdd === true) {
      problem += ' The unit group name is required.'
      this.$set(this.formErrors, 'name', 'The unit group name is required.')
      return null
    }

    console.debug('problem=' + problem)

    if (problem != '') {
      notifyProblem(problem)
      return null
    }

    let payload = ''

    if (isAdd) {
      payload = {
        name: _get(this, ['formData', 'Name'], null),
        hoaID: this.hoaId
      }
    } else {
      payload = {
        unitGroupID: this.formData.unitGroupID,
        name: _get(this, ['formData', 'Name'], null),
        hoaID: this.hoaId
      }
    }

    if (this.isDebug == true) console.debug('payload=' + JSON.stringify(payload))

    return payload
  },

  loadUnitGroup() {
    this.resetForm()
    this.selectedID = null
    this.formShow = !this.formShow
    this.action = this.action == '' ? 'add' : ''
    this.formData.UnitGroupUnitID = 0
  },

  loadUpdateUnitGroup(id) {
    if (this.isDebug == true) console.debug('loadUpdateUnitGroupID=' + id)

    this.formShow = false
    this.action = ''
    this.selectedID = null

    if (this.selectedUnitGroup && this.selectedUnitGroup != undefined) {
      this.formData.unitGroupID = _get(this, ['selectedUnitGroup', 'unitGroupID'], null)
      this.formData.Name = this.selectedUnitGroup.name

      //This may not have the action set as update
      if (!this.formData.name && this.action !== 'add') {
        this.clearName = true
      }

      //Makes sure that a non-null termination date is populated on edit load
      if (this.formData.name && (this.action === 'update' || this.action === '')) {
        console.debug('term date...' + this.formData.name)
        this.clearName = false
      }
    }

    this.selectedID = id
    this.formShow = true
    this.action = 'update'
    this.formData.UnitGroupUnitID = 0

    this.showUnitGroupModal = true
  },

  // Unit Group API calls
  async onFormSubmit() {
    await this.addUnitGroup()
  },

  async addUnitGroup() {
    if (this.isDebug == true) console.debug('in addUnitGroup unitGroupID...')

    try {
      this.loading = true

      const unitGroupPayload = this.getPayloadUnitGroup(true)
      if (unitGroupPayload === null) {
        console.error(unitGroupPayload)
        notifyProblem('Unable to add this unit group.')
        this.loading = false
        return
      }

      const results = await this.kms.post(`/Roster/UnitGroup`, unitGroupPayload)

      if (this.isDebug == true) console.debug('results=' + JSON.stringify(results))

      const unitGroupID = results.unitGroupID

      if (unitGroupID && unitGroupID > 0) {
        this.formComplete = true
        this.resetForm()
        this.getRefreshedUnitGroups()
        notifyMessage(`Successfully added unit group.`)
        this.showUnitGroupModal = false
      } else {
        notifyProblem('There was a problem adding the new unit group.')
      }
    } catch (e) {
      notifyProblem(e)
    }

    this.loading = false
  },

  async updateUnitGroup() {
    if (!this.formData.Name || !this.formData.unitGroupID) {
      notifyProblem('Unable to update this unit group.')
      return
    }

    try {
      this.loading = true

      const results = await this.kms.put(`/Roster/UnitGroup`, this.getPayloadUnitGroup(false))

      if (this.isDebug == true) console.debug(JSON.stringify(results))

      if (results && results.unitGroupID >= 0) {
        this.formComplete = true
        this.resetForm()
        this.getRefreshedUnitGroups()

        notifyMessage(`The selected unit group was successfully updated.`)

        this.showUnitGroupModal = false
      } else {
        notifyProblem('There was a problem updating this unit group.')
      }
    } catch (e) {
      notifyProblem(e)
    }

    this.loading = false
  },

  async deleteUnitGroup(id) {
    if (id <= 0) {
      notifyProblem('Unable to delete this unit group.')
      return
    }

    try {
      this.loading = true
      var deleteRow = this.rows.filter(f => f.id === id)
      console.debug(id + ' deleted row===' + JSON.stringify(deleteRow))

      const data = { unitGroupID: id, forceDelete: false }
      const path = `/Roster/UnitGroup/${id}?forceDelete=false`
      const results = await this.kms.delete(path, data)

      if (this.isDebug == true) console.debug(JSON.stringify(results))

      if (results.recordID >= 0) {
        this.formComplete = true

        notifyMessage(`The selected group was successfully deleted.`)
        this.forceReloadWithSubTab(id)
      } else {
        notifyProblem('There was a problem deleting this group.')
      }
    } catch (e) {
      notifyProblem(e)
    }

    this.loading = false
  },

  forceReloadWithSubTab(id) {
    this.$router.push('/communityCenter/unitgroupstab?i=' + id + '#tab').then(() => {
      window.location.reload()
    })
  },

  popIndexFromArray(index) {
    let counter = 0
    let spliceIndex = -1
    this.rows.forEach(f => {
      if (f.id === index) {
        spliceIndex = counter
      }
      counter = counter + 1
    })

    console.debug('spliceIndex=' + spliceIndex)
    this.rows.splice(spliceIndex, 1)
  },

  async getRefreshedUnitGroups() {
    if (this.hoaId !== undefined && this.hoaId) {
      const params = {
        hoaID: this.hoaId
      }

      console.debug('params=' + JSON.stringify(params))

      const { results } = await this.kms.get(`/Roster/UnitGroup/List`, {
        params
      })

      this.unitGroupList = results
      this.formData.UnitGroupID = 0
      this.formData.UnitGroupUnitID = 0

      console.debug('unitGroupList=' + JSON.stringify(results))

      this.initButtons()
    }
  },

  filterList() {
    if (this.filterBy && this.unitList) {
      if (this.filterBy.length === 0) {
        this.unitList = this.unitListCopy
      } else {
        this.unitList = this.unitList.filter(
          f =>
            f.address.addressOne.indexOf(this.filterBy) !== -1 ||
            (f.address.city !== undefined && f.address.city.indexOf(this.filterBy) !== -1) ||
            (f.address.region !== undefined && f.address.region.indexOf(this.filterBy) !== -1) ||
            (f.address.postalCode !== undefined &&
              f.address.postalCode.indexOf(this.filterBy) !== -1)
        )
      }
    } else {
      this.unitList = this.unitListCopy
    }
  },

  async getRefreshedUnitGroupUnits(unitGroupID) {
    if (unitGroupID !== undefined && unitGroupID) {
      const params = {
        unitGroupID
      }

      console.debug('params=' + JSON.stringify(params))

      const { results } = await this.kms.get(`/Roster/UnitGroupUnit/List`, {
        params
      })

      this.unitGroupList = results

      console.debug('unitGroupUnitList=' + JSON.stringify(results))
    }
  },

  // Unit Group Unit methods
  confirmDeleteUnitGroupUnit(id, unitName) {
    this.$buefy.dialog.confirm({
      title: 'Deleting Unit',
      message: `Are you sure you want to <b>delete</b> this unit: ${unitName}?`,
      confirmText: 'Delete Unit',
      type: 'is-danger',
      hasIcon: true,
      onConfirm: () => this.deleteUnitGroupUnit(id)
    })
  },

  async openUnitGroupUnitModal({ unitGroupID }) {
    this.resetForm()
    this.selectedID = null

    this.selectedUnitGroupID = unitGroupID
    await this.loadUnits()

    this.action = 'addunitgroupunit'
    this.formData.UnitGroupUnitID = 0
    this.formData.UnitGroupID = unitGroupID

    this.showUnitGroupUnitModal = true
  },

  getPayloadUnitGroupUnit() {
    if (this.isDebug == true) console.debug('this.formData=' + JSON.stringify(this.formData))

    let notifyMessage = ''
    if (!this.formData.UnitName || this.formData.UnitName == undefined) {
      notifyMessage = 'Unit Group Unit Name is required.'
    }

    if (!this.formData.UnitGroupID || this.formData.UnitGroupID == undefined) {
      notifyMessage += 'Unit Group ID is required.'
    }

    if (notifyMessage != '') {
      notifyProblem(notifyMessage)
      return
    }

    const payload = {
      unitGroupUnitID: this.formData.UnitGroupUnitID,
      unitGroupID:
        this.formData.UnitGroupID &&
        this.formData.UnitGroupID != undefined &&
        this.formData.UnitGroupID > 0
          ? this.formData.UnitGroupID
          : this.selectedUnitGroupID,
      unitID: _get(this, ['formData', 'UnitID'], null)
    }

    if (this.isDebug == true) console.debug('payload=' + JSON.stringify(payload))

    return payload
  },

  loadUpdateUnitGroupUnit(id, unit) {
    this.resetForm()

    console.debug('in loadUpdateUnitGroupUnit...' + id)

    this.selectedUnitGroupUnit = unit

    if (unit && unit != undefined) {
      this.formData.UnitGroupUnitID = id
      this.formData.UnitGroupID = unit.unitGroupID

      if (this.isDebug == true)
        console.debug(
          'loadUpdateUnitGroupUnit=' + id + ' formData=' + JSON.stringify(this.formData)
        )
    }

    this.selectedID = id
    this.formShow = true
    this.action = 'updateunitgroupunit'

    this.showUnitGroupUnitModal = true
  },

  // Unit Group Unit API calls
  async addUnitGroupUnit() {
    const unitGroupID = this.selectedUnitGroupID

    console.debug('in addUnitGroupUnit()...' + unitGroupID)

    this.unitIds = []

    if (!this.checkedRows || this.checkedRows == undefined || this.checkedRows.length === 0) {
      notifyError('At least one homeowner is required.')
      return
    }

    console.debug('checkedRows===' + JSON.stringify(this.checkedRows))

    Array.from(this.checkedRows).forEach(element => {
      if (element) {
        if (this.isDebug === true) console.debug('element' + JSON.stringify(element))

        if (element.unitID && element.unitID != undefined) {
          this.unitIds.push(element.unitID)
        }
      }
    })

    console.debug('addUnitGroupUnit===' + JSON.stringify(this.unitIds))

    try {
      this.loading = true

      let results = null

      const payload = {
        unitGroupID: unitGroupID,
        unitIds: this.unitIds
      }

      try {
        results = await this.kms.post(
          `/Roster/UnitGroupUnit/UpsertUnitGroupUnitFromCollectionOfIds`,
          payload
        )
      } catch (exception) {
        this.showFormValidationErrors({
          exception
        })

        this.loading = false

        return
      }

      if (this.isDebug == true) console.debug('results=' + JSON.stringify(results))

      if (results) {
        this.formComplete = true
        notifyMessage(`Successfully updated all checked units.`)
        this.forceReloadWithSubTab(results.unitGroupUnitID)
        this.showUnitGroupUnitModal = false
      } else {
        notifyProblem('There was a problem adding the new group.')
      }
    } catch (e) {
      notifyProblem(e)
    }

    this.loading = false
  },

  async loadUnits() {
    try {
      const { results: units } = await this.kms.get('/Roster/Unit/List', {
        params: {
          hoaID: this.hoaId,
          includeOwnerContacts: false,
          startRecord: 1,
          recordCount: 10000
        }
      })

      this.unitListCopy = _cloneDeep(units)
      this.unitList = units

      console.debug('unitList===' + JSON.stringify(this.unitList))

      //this.parseUnitRows()
    } catch (e) {
      notifyProblem(e)
    }
  },

  async updateUnitGroupUnit() {
    if (!this.formData || !this.formData.UnitGroupUnitID || this.formData.UnitGroupUnitID <= 0) {
      notifyProblem('Unable to update this unit.')
      return
    }

    try {
      this.loading = true

      let results = null
      try {
        results = await this.kms.put(`/Roster/UnitGroupUnit`, this.getPayloadUnitGroupUnit())
      } catch (exception) {
        this.showFormValidationErrors({
          exception
        })

        this.loading = false

        return
      }

      if (this.isDebug == true) console.debug(JSON.stringify(results))

      if (results && results.unitGroupUnitID >= 0) {
        this.formComplete = true
        this.resetForm()
        this.getRefreshedUnitGroups()

        notifyMessage(`The selected unit was successfully updated.`)

        this.showUnitGroupUnitModal = false
      } else {
        notifyProblem('There was a problem updating this unit.')
      }
    } catch (e) {
      notifyProblem(e)
    }
    this.loading = false
  },

  async deleteUnitGroupUnit(id) {
    if (id <= 0) {
      notifyProblem('Unable to delete this unit.')
      return
    }

    try {
      this.loading = true
      const data = { unitGroupUnitID: id, forceDelete: false }
      const path = `/Roster/UnitGroupUnit/${id}?forceDelete=false`
      const results = await this.kms.delete(path, data)

      if (this.isDebug == true) console.debug(JSON.stringify(results))

      if (results.recordID >= 0) {
        this.formComplete = true

        this.getRefreshedUnitGroups()

        notifyMessage(`The selected unit was successfully deleted.`)
      } else {
        notifyProblem('There was a problem deleting this unit.')
      }
    } catch (e) {
      notifyProblem(e)
    }

    this.loading = false
  }
}
